var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import Logo from '@doordash/component-logo';
import { Icon, InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import OptInStrings from './OptInStrings';
import { TitleContainer, HowToContainer, PageTitleText, PageSubtitleText, OptInScreenContainer, HeaderContainer, EnrollRedBackgroundContainer, FlexContainer, FullScreenContainer, } from './OptInStyles';
import ListCell from '@doordash/component-list-cell';
import EnrollInput from './EnrollInput';
import VerifyEmailAddressModal from './VerifyEmailAddressModal';
import { useMediaQuery } from '../Common/MediaQueryProvider';
import { useInviteTeamMemberByOptInMutation } from './useInviteTeamMemberByOptInMutation';
import track from '../../utils/track';
import { OptInEvents } from '../../constants/events/names';
import { useGetConsumerInfo } from '../DynamicValues/hook';
import { getDomainNameFromEmail } from './utils';
import { useGetTeamMemberEmail } from './useGetTeamMemberEmail';
var Header = function () {
    return (React.createElement(HeaderContainer, null,
        React.createElement(Logo, { type: Logo.Types.LogoMark, size: Logo.Sizes.Medium, text: "For Work" })));
};
var TitleContent = function () {
    return (React.createElement(TitleContainer, null,
        React.createElement(PageTitleText, null, OptInStrings.pageTitle()),
        React.createElement(Stack, null),
        React.createElement(PageSubtitleText, null, OptInStrings.pageSubtitle())));
};
var HowToSteps = function (_a) {
    var isMobile = _a.isMobile;
    var steps = [
        {
            title: OptInStrings.howToEnroll.step1.title(),
            subtext: OptInStrings.howToEnroll.step1.subtext(),
            icon: Icon.Types.Number1Fill,
        },
        {
            title: OptInStrings.howToEnroll.step2.title(),
            subtext: OptInStrings.howToEnroll.step2.subtext(),
            icon: Icon.Types.Number2Fill,
        },
        {
            title: OptInStrings.howToEnroll.step3.title(),
            subtext: OptInStrings.howToEnroll.step3.subtext(),
            icon: Icon.Types.Number3Fill,
        },
    ];
    // Display side-by-side on desktop, and top-bottom on mobile
    var DisplayWrapper = isMobile ? StackChildren : InlineChildren;
    var displayWrapperProps = isMobile
        ? {}
        : { alignItems: InlineChildren.Alignment.Center };
    return (React.createElement(HowToContainer, null,
        React.createElement(DisplayWrapper, __assign({}, displayWrapperProps),
            React.createElement(StackChildren, null,
                React.createElement(Text, { styles: Text.Styles.PageTitle2 }, OptInStrings.howToEnroll.title()),
                React.createElement(Text, { styles: Text.Styles.Label1, color: Text.Colors.TextTertiary }, OptInStrings.howToEnroll.subtext())),
            React.createElement(StackChildren, null, steps.map(function (step, index) { return (React.createElement(ListCell, { key: "step-" + index, title: step.title, subtext: step.subtext, secondaryTitleStart: React.createElement(Icon, { type: step.icon }), isSeparatorVisible: false, titleMaxLines: 2, subtextMaxLines: 4 })); })))));
};
export var OptIn = function () {
    var _a = __read(React.useState(false), 2), isVerifyEmailAddressModalOpen = _a[0], setIsVerifyEmailAddressModalOpen = _a[1];
    var isMobile = useMediaQuery().isMobile;
    var _b = useInviteTeamMemberByOptInMutation(), inviteTeamMemberByOptIn = _b.inviteTeamMemberByOptIn, isOptInLoading = _b.loading;
    var _c = useGetConsumerInfo(), isGuest = _c.isGuest, isConsumerInfoLoading = _c.loading;
    var teamMemberData = useGetTeamMemberEmail().data;
    React.useEffect(function () {
        // fire page view track event
        if (!isConsumerInfoLoading) {
            track(OptInEvents.PAGE_VIEW, {
                is_logged_in: !isGuest,
            });
        }
    }, [isConsumerInfoLoading, isGuest]);
    var onEnroll = function (emailToEnroll) {
        var _a, _b;
        var userEmail = ((_b = (_a = teamMemberData === null || teamMemberData === void 0 ? void 0 : teamMemberData.getTeamMemberPortalData) === null || _a === void 0 ? void 0 : _a.teamMember) === null || _b === void 0 ? void 0 : _b.email) || '';
        track(OptInEvents.SUBMIT_EMAIL, {
            is_logged_in: !isGuest,
            is_opt_in_for_self: !!userEmail && userEmail === emailToEnroll,
            opt_in_email_domain: getDomainNameFromEmail(emailToEnroll),
        });
        inviteTeamMemberByOptIn(emailToEnroll, {
            onCompleted: function () {
                // do not need `if response?.inviteTeamMemberByOptIn?.completed`
                // there are currently no other responses available at this time
                setIsVerifyEmailAddressModalOpen(true);
            },
        });
    };
    return (React.createElement(FullScreenContainer, null,
        React.createElement(OptInScreenContainer, null,
            React.createElement(Header, null),
            React.createElement(TitleContent, null),
            React.createElement(EnrollRedBackgroundContainer, null,
                React.createElement(FlexContainer, null,
                    React.createElement(EnrollInput, { isMobile: isMobile, isLoading: isOptInLoading, onEnroll: onEnroll }))),
            React.createElement(HowToSteps, { isMobile: isMobile })),
        isVerifyEmailAddressModalOpen && (React.createElement(VerifyEmailAddressModal, { onClose: function () { return setIsVerifyEmailAddressModalOpen(false); } }))));
};
export default OptIn;
